import { defineMessages } from 'react-intl';

export default defineMessages({
  items: {
    id: 'accordion.header.items',
    defaultMessage: '{count} items',
  },
  date: {
    id: 'accordion.header.date',
    defaultMessage: 'Of {date}',
  },
});
